// import axios from "axios";
// import { useEffect, useState } from "react";
// import Navbar from "../Navbar";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import Swal from "sweetalert2";
// import Footer from "../Footer";
// import { useNavigate } from "react-router-dom";
// import { useOutlet } from "../../context/OutletContext";
// import { FaRegSquareCheck } from "react-icons/fa6";
// import ManageActions from "./ManageActions";

// const Registeruser = () => {
//   const [token, setToken] = useState('')
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [type, setType] = useState("admin");
//   const [isPasswordVisible, setIsPasswordVisible] = useState(false);
//   const [errordel, setErrordel] = useState("");
//   const [erroredit, setErroredit] = useState("");
//   const [data, setData] = useState([]);
//   const [ErrorUserMsg, setErrorUserMsgMsg] = useState(null);
//   const [messagedel, setMessagedel] = useState(true);
//   const [messageedit, setMessageedit] = useState(true);
//   const [oldusername, setOldUsername] = useState("");
//   const [deleteconfirm, setDeleteConfirm] = useState(false);
//   const [editconfirm, setEditConfirm] = useState(false);
//   const [editsectionmsg, setEditSectionMsg] = useState(false);
//   const [showCancelButton, setShowCancelButton] = useState(false);
//   const [registermsg, setRegisterMsg] = useState("");
//   const [selectedOutlets, setSelectedOutlets] = useState([]);
//   const [selectEnabled, setSelectEnabled] = useState(false);
//   const [showOutlets, setShowOutlets] = useState(true);

//   const [outletManagement, setOutletManagement] = useState({
//     show: false,
//     userId: null,
//     username: "",
//     currentOutlets: [],
//   });

//   let url = process.env.REACT_APP_BASE_URL;
//   let baseURL = process.env.REACT_APP_LEDGER_URL;
//   const navigate = useNavigate();

//   const { outletOptions } = useOutlet();

//   const toggleOutlet = (outlet) => {
//     setSelectedOutlets((prev) =>
//       prev.includes(outlet)
//         ? prev.filter((o) => o !== outlet)
//         : [...prev, outlet]
//     );
//   };

//   useEffect(() => {
//     if (!selectEnabled) {
//       setSelectedOutlets(outletOptions);
//     } else {
//       setSelectedOutlets([]);
//     }
//   }, [selectEnabled, outletOptions]);


//   useEffect(() => {
//     let tokenCheck = sessionStorage.getItem("token");
//     let typeCheck = sessionStorage.getItem("type")

//     if (tokenCheck === null && typeCheck !== 'admin') {
//       navigate("/");
//     } else {
//       setToken(tokenCheck);
//       sessionStorage.setItem('token', tokenCheck);
//     }
//   }, [token, navigate]);

//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setMessagedel(false);
//       setErrordel(false);
//       setErrorUserMsgMsg(false);
//       setMessageedit(false);
//       setRegisterMsg(false);
//       setErroredit(false);
//     }, 5000);
//     return () => clearTimeout(timeout);
//   }, [ErrorUserMsg, errordel, erroredit, messageedit, registermsg, messagedel]);

//   const handleUsernameChange = (e) => {
//     setUsername(e.target.value);
//   };

//   const handlePasswordChange = (e) => {
//     setPassword(e.target.value);
//   };

//   const handleTypeChange = (e) => {
//     setType(e.target.value);
//   };

//   const resetForm = () => {
//     setUsername("");
//     setPassword("");
//     setType("admin");
//     setEditConfirm(false);
//     setEditSectionMsg(false);
//     setShowCancelButton(false);
//     setShowOutlets(true);
//   };

//   const fetchUserData = async () => {
//     if (!token) return;

//     try {
//       let userlist = { token: token, username: sessionStorage.getItem("user") };
//       const response = await axios.post(`${url}/userlists`, userlist);


//       if (response.data && Array.isArray(response.data.users)) {
//         setData(response.data.users);
//       } else if (response.data && Array.isArray(response.data)) {
//         setData(response.data);
//       } else {
//         console.error("Unexpected response format", response.data);
//         setData([]);
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setData([]);
//     }
//   };

//   useEffect(() => {
//     fetchUserData();
//   }, [deleteconfirm, registermsg, messageedit, messagedel, token]);

//   const toggleVisibility = (e) => {
//     e.preventDefault();
//     setIsPasswordVisible(!isPasswordVisible);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (editconfirm) {
//       try {
//         const usereditData = {
//           token: "test",
//           username: oldusername,
//           new_username: username,
//           new_password: password,
//           new_type: type,
//           restaurantURL: url,
//           baseURL: baseURL || "",
//         };

//         await axios.post(`${url}/edituser`, usereditData);
//         setMessageedit("User edited successfully!");
//         setSelectedOutlets([]);
//         setSelectEnabled(false);
//         resetForm();
//       } catch (error) {
//         console.log(error);
//       }
//     } else {
//       try {
//         const userData = {
//           username,
//           password,
//           type,
//           restaurantURL: url,
//           baseURL: baseURL || "",
//           outlets: selectedOutlets
//         };

//         await axios.post(`${url}/register`, userData);
//         setRegisterMsg("User Registered Successfully");
//         resetForm();
//         setSelectedOutlets([]);
//         setSelectEnabled(false);
//       } catch (error) {
//         console.log(error);
//       }
//     }
//   };

//   const handleAlert = async (username) => {
//     let postdata = { token: "test", username: username };
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         Swal.fire({
//           title: "Deleted!",
//           text: "User has been deleted.",
//           icon: "success",
//         });
//         setDeleteConfirm(true);
//         try {
//           axios.post(`${url}/deleteuser`, postdata);
//           setMessagedel("User deleted successfully!");
//           setErrordel("");
//         } catch (error) {
//           if (error.response && error.response.data) {
//             setErrordel(error.response.data.message || "Failed to delete user");
//           } else {
//             setErrordel("An error occurred while deleting the user.");
//           }
//         }
//       }
//     });
//   };

//   const handleEditAlert = async (username, password, type) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "You want to edit user!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, edit user!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         setEditConfirm(true);
//         setEditSectionMsg(true);
//         setShowCancelButton(true);
//         setUsername(username);
//         setPassword(password);
//         setType(type);
//         setOldUsername(username);
//         setShowOutlets(false);
//       }
//     });
//   };

//   const handleManageOutlets = (userId, username, outlets) => {
//     setOutletManagement({
//       show: true,
//       userId,
//       username,
//       currentOutlets: outlets || [],
//     });
//   };

//   const handleCloseOutletManagement = () => {
//     setOutletManagement({
//       show: false,
//       userId: null,
//       username: "",
//       currentOutlets: [],
//     });
//   };

//   const handleAddOutlet = async (outlet) => {
//     const result = await Swal.fire({
//       title: "Add Outlet?",
//       text: `Add ${outlet} to ${outletManagement.username}'s outlets?`,
//       icon: "question",
//       showCancelButton: true,
//       confirmButtonText: "Yes, add it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonColor: "#2563EB",
//       cancelButtonColor: "#9CA3AF",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.post(`${url}/assign-outlet`, {
//           token: token,
//           user_id: outletManagement.userId,
//           outlet: outlet,
//         });
//         setOutletManagement(prev => ({
//           ...prev,
//           currentOutlets: [...prev.currentOutlets, outlet]
//         }));
//         Swal.fire({
//           title: "Added!",
//           text: "Outlet has been added.",
//           icon: "success",
//           confirmButtonColor: "#2563EB"
//         });
//         fetchUserData();
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to add outlet.",
//           icon: "error",
//           confirmButtonColor: "#DC2626"
//         });
//       }
//     }
//   };

//   const handleRemoveOutlet = async (outlet) => {
//     const result = await Swal.fire({
//       title: "Remove Outlet?",
//       text: `Remove ${outlet} from ${outletManagement.username}'s outlets?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes, remove it!",
//       cancelButtonText: "No, cancel!",
//       confirmButtonColor: "#DC2626",
//       cancelButtonColor: "#9CA3AF",
//     });

//     if (result.isConfirmed) {
//       try {
//         await axios.post(`${url}/remove-outlet`, {
//           token: token,
//           user_id: outletManagement.userId,
//           outlet: outlet,
//         });
//         setOutletManagement(prev => ({
//           ...prev,
//           currentOutlets: prev.currentOutlets.filter(o => o !== outlet)
//         }));
//         Swal.fire({
//           title: "Removed!",
//           text: "Outlet has been removed.",
//           icon: "success",
//           confirmButtonColor: "#2563EB"
//         });
//         fetchUserData();
//       } catch (error) {
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to remove outlet.",
//           icon: "error",
//           confirmButtonColor: "#DC2626"
//         });
//       }
//     }
//   };

//   return (
//     <div className="flex flex-col min-h-screen">
//       <Navbar />

//       <div className="flex-grow">
//         <div className="container mx-auto p-4">
//           <div className="flex flex-col md:flex-row gap-24">
//             <div className="w-1/3">
//               <form
//                 autoComplete="off"
//                 onSubmit={handleSubmit}
//                 className="bg-white p-6 rounded-lg shadow-md max-w-md"
//               >
//                 <h2 className="text-xl font-semibold mb-4">
//                   {editsectionmsg ? "Edit Existing User" : "Register New User"}
//                 </h2>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="username">
//                     Username
//                   </label>
//                   <input
//                     type="text"
//                     id="username"
//                     className="w-full px-3 py-2 border rounded"
//                     autoComplete="new-username"
//                     value={username}
//                     onChange={handleUsernameChange}
//                     required
//                     disabled={editconfirm}
//                   />
//                   {ErrorUserMsg && (
//                     <p className="text-red-500 mt-1">{ErrorUserMsg}</p>
//                   )}
//                 </div>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="password">
//                     Password
//                   </label>
//                   <div className="flex items-center">
//                     <input
//                       type={isPasswordVisible ? "text" : "password"}
//                       id="password"
//                       className="w-full px-3 py-2 border rounded"
//                       autoComplete="new-password"
//                       value={password}
//                       onChange={handlePasswordChange}
//                       required
//                     />
//                     <button
//                       type="button"
//                       className="ml-2 p-2"
//                       onClick={toggleVisibility}
//                     >
//                       {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
//                     </button>
//                   </div>
//                 </div>

//                 <div className="mb-4">
//                   <label className="block text-gray-700 mb-2" htmlFor="type">
//                     User Type
//                   </label>
//                   <select
//                     id="type"
//                     className="w-full px-3 py-2 border rounded"
//                     value={type}
//                     onChange={handleTypeChange}
//                   >
//                     <option value="admin">Admin</option>
//                     <option value="agent">Agent</option>
//                     <option value="kitchen">Kitchen</option>
//                   </select>
//                 </div>

//                 {showOutlets &&
//                   <div className="mb-4">
//                     <label className="flex items-center gap-2 mb-2 text-gray-700">
//                       <input
//                         type="checkbox"
//                         checked={selectEnabled}
//                         onChange={(e) => setSelectEnabled(e.target.checked)}
//                       />
//                       Select Outlets?
//                     </label>
//                     {selectEnabled &&
//                       <div className="border rounded p-2 w-full">
//                         {outletOptions.map((outlet, idx) => {
//                           const isSelected = selectedOutlets.includes(outlet);
//                           return (
//                             <div
//                               key={idx}
//                               onClick={() => toggleOutlet(outlet)}
//                               className={`flex items-center cursor-pointer px-2 py-1 rounded 
//                             ${isSelected ? "bg-gray-100" : ""}`}
//                             >
//                               <span className="mr-2">
//                                 {isSelected ? <FaRegSquareCheck className="h-5 w-5 text-green-700" /> : <FaRegSquareCheck className="h-5 w-5 text-gray-500" />}
//                               </span>
//                               <span>{outlet}</span>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     }
//                   </div>
//                 }

//                 <div className="flex items-center">
//                   <button
//                     type="submit"
//                     className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2"
//                   >
//                     {editsectionmsg ? "Update" : "Register"}
//                   </button>

//                   {showCancelButton && (
//                     <button
//                       type="button"
//                       className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
//                       onClick={resetForm}
//                     >
//                       Cancel
//                     </button>
//                   )}
//                 </div>

//                 {registermsg && (
//                   <p className="text-green-500 mt-2">{registermsg}</p>
//                 )}
//               </form>
//             </div>

//             <div className="w-full md:w-2/3">
//               <div className="bg-white p-6 rounded-lg shadow-md">
//                 <h2 className="text-xl font-semibold mb-4">Registered Users</h2>

//                 {errordel && <div className="text-red-500 mb-4">{errordel}</div>}
//                 {messagedel && (
//                   <div className="text-green-500 mb-4">{messagedel}</div>
//                 )}
//                 {erroredit && <div className="text-red-500 mb-4">{erroredit}</div>}
//                 {messageedit && (
//                   <div className="text-green-500 mb-4">{messageedit}</div>
//                 )}

//                 <div className="overflow-x-auto max-h-[350px] overflow-y-auto">
//                   <table className="min-w-full bg-white">
//                     <thead>
//                       <tr>
//                         <th className="py-2 px-4 border-b text-left">Username</th>
//                         <th className="py-2 px-4 border-b text-left">Password</th>
//                         <th className="py-2 px-4 border-b text-left">Type</th>
//                         <th className="py-2 px-4 border-b text-left">Outlet</th>
//                         <th className="py-2 px-4 border-b text-left">Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {Array.isArray(data) &&
//                         data.map((item, index) => (
//                           <tr key={index}>
//                             <td className="py-2 px-4 border-b">{item.username}</td>
//                             <td className="py-2 px-4 border-b">{item.password}</td>
//                             <td className="py-2 px-4 border-b">{item.type}</td>
//                             <td className="py-2 px-4 border-b whitespace-pre-line">
//                               {item.outlets?.join("\n")}
//                             </td>
//                             <td className="py-2 px-4 border-b">
//                               <ManageActions
//                                 item={item}
//                                 handleAlert={handleAlert}
//                                 handleEditAlert={handleEditAlert}
//                                 handleManageOutlets={handleManageOutlets}
//                               />
//                             </td>
//                           </tr>
//                         ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {outletManagement.show && (
//             <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//               <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
//                 <div className="flex justify-between items-center mb-4">
//                   <h2 className="text-lg font-semibold">
//                     Manage Outlets for {outletManagement.username}
//                   </h2>
//                   <button
//                     onClick={handleCloseOutletManagement}
//                     className="text-gray-500 hover:text-gray-700"
//                   >
//                     ✕
//                   </button>
//                 </div>

//                 <div className="mb-4">
//                   <h3 className="font-medium mb-2 text-lg">Current Outlets:</h3>
//                   {outletManagement.currentOutlets.length > 0 ? (
//                     <div className="space-y-2">
//                       {outletManagement.currentOutlets.map((outlet, idx) => (
//                         <div
//                           key={idx}
//                           className="flex items-center justify-between bg-gray-100 p-2 rounded"
//                         >
//                           <span>{outlet}</span>
//                           <button
//                             onClick={() => handleRemoveOutlet(outlet)}
//                             className="text-red-500 hover:text-red-700"
//                           >
//                             Remove
//                           </button>
//                         </div>
//                       ))}
//                     </div>
//                   ) : (
//                     <p className="text-gray-500">No outlets assigned</p>
//                   )}
//                 </div>

//                 <div>
//                   <h3 className="font-medium mb-2 text-lg">Available Outlets:</h3>
//                   <div className="space-y-2">
//                     {outletOptions
//                       .filter(o => !outletManagement.currentOutlets.includes(o))
//                       .map((outlet, idx) => (
//                         <div
//                           key={idx}
//                           className="flex items-center justify-between p-2 hover:bg-gray-50 rounded cursor-pointer"
//                           onClick={() => handleAddOutlet(outlet)}
//                         >
//                           <span>{outlet}</span>
//                           <button className="text-green-500 hover:text-green-700">
//                             Add
//                           </button>
//                         </div>
//                       ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           )}

//         </div>
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default Registeruser;





import axios from "axios";
import { useEffect, useState } from "react";
import Navbar from "../Navbar";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Swal from "sweetalert2";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";
// import CounterUserManagement from "./CounterUserRegister";
// import FranchiseUserManagement from "./FranchiseUser";

const Registeruser = () => {
  const [token, setToken] = useState('')
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState("admin");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [errordel, setErrordel] = useState("");
  const [erroredit, setErroredit] = useState("");
  const [data, setData] = useState([]);
  const [ErrorUserMsg, setErrorUserMsgMsg] = useState(null);
  const [messagedel, setMessagedel] = useState(true);
  const [messageedit, setMessageedit] = useState(true);
  const [oldusername, setOldUsername] = useState("");
  const [deleteconfirm, setDeleteConfirm] = useState(false);
  const [editconfirm, setEditConfirm] = useState(false);
  const [editsectionmsg, setEditSectionMsg] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [registermsg, setRegisterMsg] = useState("");
  let url = process.env.REACT_APP_BASE_URL;
  let baseURL = process.env.REACT_APP_LEDGER_URL;
  const navigate = useNavigate();

  useEffect(() => {
    let tokenCheck = sessionStorage.getItem("token");
    let typeCheck = sessionStorage.getItem("type")

    if (tokenCheck === null && typeCheck !== 'admin') {
      navigate("/");
    } else {
      setToken(tokenCheck);
      sessionStorage.setItem('token', tokenCheck);
    }
  }, [token, navigate]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setMessagedel(false);
      setErrordel(false);
      setErrorUserMsgMsg(false);
      setMessageedit(false);
      setRegisterMsg(false);
      setErroredit(false);
    }, 5000);
    return () => clearTimeout(timeout);
  }, [ErrorUserMsg, errordel, erroredit, messageedit, registermsg, messagedel]);

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleTypeChange = (e) => {
    setType(e.target.value);
  };

  const resetForm = () => {
    setUsername("");
    setPassword("");
    setType("admin");
    setEditConfirm(false);
    setEditSectionMsg(false);
    setShowCancelButton(false);
  };

  const fetchUserData = async () => {
    if (!token) return;

    try {
      let userlist = { token: token, username: sessionStorage.getItem("user") };
      const response = await axios.post(`${url}/userlists`, userlist);

      if (response.data && Array.isArray(response.data.users)) {
        setData(response.data.users);
      } else if (response.data && Array.isArray(response.data)) {
        setData(response.data);
      } else {
        console.error("Unexpected response format", response.data);
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [deleteconfirm, registermsg, messageedit, messagedel, token]);

  const toggleVisibility = (e) => {
    e.preventDefault();
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (editconfirm) {
      try {
        const usereditData = {
          token: "test",
          username: oldusername,
          new_username: username,
          new_password: password,
          new_type: type,
          restaurantURL: url,
          baseURL: baseURL || "",
        };

        await axios.post(`${url}/edituser`, usereditData);
        setMessageedit("User edited successfully!");
        resetForm();
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        const userData = {
          username,
          password,
          type,
          restaurantURL: url,
          baseURL: baseURL || ""
        };

        await axios.post(`${url}/register`, userData);
        setRegisterMsg("User Registered Successfully");
        resetForm();
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleAlert = async (username) => {
    let postdata = { token: "test", username: username };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Deleted!",
          text: "User has been deleted.",
          icon: "success",
        });
        setDeleteConfirm(true);
        try {
          axios.post(`${url}/deleteuser`, postdata);
          setMessagedel("User deleted successfully!");
          setErrordel("");
        } catch (error) {
          if (error.response && error.response.data) {
            setErrordel(error.response.data.message || "Failed to delete user");
          } else {
            setErrordel("An error occurred while deleting the user.");
          }
        }
      }
    });
  };

  const handleEditAlert = async (username, password, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to edit user!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, edit user!",
    }).then((result) => {
      if (result.isConfirmed) {
        setEditConfirm(true);
        setEditSectionMsg(true);
        setShowCancelButton(true);
        setUsername(username);
        setPassword(password);
        setType(type);
        setOldUsername(username);
      }
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow">
        <div className="container mx-auto p-4">
          <div className="flex flex-col md:flex-row gap-24">
            <div className="w-1/3">
              <form
                autoComplete="off"
                onSubmit={handleSubmit}
                className="bg-white p-6 rounded-lg shadow-md max-w-md"
              >
                <h2 className="text-xl font-semibold mb-4">
                  {editsectionmsg ? "Edit Existing User" : "Register New User"}
                </h2>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="username">
                    Username
                  </label>
                  <input
                    type="text"
                    id="username"
                    className="w-full px-3 py-2 border rounded"
                    autoComplete="new-username"
                    value={username}
                    onChange={handleUsernameChange}
                    required
                    disabled={editconfirm}
                  />
                  {ErrorUserMsg && (
                    <p className="text-red-500 mt-1">{ErrorUserMsg}</p>
                  )}
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="password">
                    Password
                  </label>
                  <div className="flex items-center">
                    <input
                      type={isPasswordVisible ? "text" : "password"}
                      id="password"
                      className="w-full px-3 py-2 border rounded"
                      autoComplete="new-password"
                      value={password}
                      onChange={handlePasswordChange}
                      required
                    />
                    <button
                      type="button"
                      className="ml-2 p-2"
                      onClick={toggleVisibility}
                    >
                      {isPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="block text-gray-700 mb-2" htmlFor="type">
                    User Type
                  </label>
                  <select
                    id="type"
                    className="w-full px-3 py-2 border rounded"
                    value={type}
                    onChange={handleTypeChange}
                  >
                    <option value="admin">Admin</option>
                    <option value="agent">Agent</option>
                    <option value="kitchen">Kitchen</option>
                  </select>
                </div>

                <div className="flex items-center">
                  <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded mr-2"
                  >
                    {editsectionmsg ? "Update" : "Register"}
                  </button>

                  {showCancelButton && (
                    <button
                      type="button"
                      className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                  )}
                </div>

                {registermsg && (
                  <p className="text-green-500 mt-2">{registermsg}</p>
                )}
              </form>
            </div>

            <div className="w-full md:w-2/3">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h2 className="text-xl font-semibold mb-4">Registered Users</h2>

                {errordel && <div className="text-red-500 mb-4">{errordel}</div>}
                {messagedel && (
                  <div className="text-green-500 mb-4">{messagedel}</div>
                )}
                {erroredit && <div className="text-red-500 mb-4">{erroredit}</div>}
                {messageedit && (
                  <div className="text-green-500 mb-4">{messageedit}</div>
                )}

                <div className="overflow-x-auto max-h-[350px] overflow-y-auto">
                  <table className="min-w-full bg-white">
                    <thead>
                      <tr>
                        <th className="py-2 px-4 border-b text-left">Username</th>
                        <th className="py-2 px-4 border-b text-left">Password</th>
                        <th className="py-2 px-4 border-b text-left">Type</th>
                        <th className="py-2 px-4 border-b text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(data) &&
                        data.map((item, index) => (
                          <tr key={index}>
                            <td className="py-2 px-4 border-b">{item.username}</td>
                            <td className="py-2 px-4 border-b">{item.password}</td>
                            <td className="py-2 px-4 border-b">{item.type}</td>
                            <td className="py-2 px-4 border-b">
                              <div className="flex flex-col space-y-1">
                                <button
                                  className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                  onClick={() => {
                                    handleAlert(item.username);
                                  }}
                                >
                                  Delete
                                </button>
                                <button
                                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                                  onClick={() => {
                                    handleEditAlert(
                                      item.username,
                                      item.password,
                                      item.type
                                    );
                                  }}
                                >
                                  Edit
                                </button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* <CounterUserManagement url={url} /> */}
          {/* <FranchiseUserManagement url={url} /> */}

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Registeruser;